
import axios from '../utils/ajax'
// 代理商列表
export const queryUnit = params => axios.get('/managementPlatform/thailand/queryUnit',{params})
// 新增编辑代理商门店
export const createOrUpdateUnit = params => axios.get('/managementPlatform/thailand/createOrUpdateUnit',{params})
// 删除代理商门店
export const deleteAgentAndShopUnit = params => axios.get('/managementPlatform/thailand/deleteAgentAndShopUnit',{params})
// 代理商树结构
export const queryUnitTree = params => axios.get('/managementPlatform/thailand/queryUnitTree',{params})



// WEBPACK FOOTER //
// ./src/api/agent.js